export default "__VITE_ASSET__B6ao$TEV__"